import { AssignmentApi, Assignment } from '../models';

export function mapAssignmentApiToAssignment(
  assignmentApi: AssignmentApi
): Assignment {
  return {
    id: assignmentApi.id,
    name: assignmentApi.name,
    feeService: assignmentApi.feeService,
    driver: assignmentApi.driver
      ? {
          id: assignmentApi.driver.id,
          firstName: assignmentApi.driver.name,
          lastName: assignmentApi.driver.lastName,
          phone: assignmentApi.driver.phone,
          email: assignmentApi.driver.email,
          costRange: assignmentApi.driver.costRange,
          lastCost: assignmentApi.driver.lastCost,
        }
      : undefined,
    companion: assignmentApi.companion
      ? {
          id: assignmentApi.companion.id,
          firstName: assignmentApi.companion.name,
          lastName: assignmentApi.companion.lastName,
          phone: assignmentApi.companion.phone,
          email: assignmentApi.companion.email,
          costRange: assignmentApi.companion.costRange, // Agregar estas propiedades
          lastCost: assignmentApi.companion.lastCost, // Agregar estas propiedades
        }
      : null,
    vehicle: assignmentApi.vehicle
      ? {
          id: assignmentApi.vehicle?.id,
          description: assignmentApi.vehicle?.description,
          plate: assignmentApi.vehicle?.plateNumber,
          type: assignmentApi.vehicle?.vehicleType,
        }
      : null,
    profit: {
      percentage: assignmentApi.profitOrLoss,
      amount: assignmentApi.profitOrLossAmount,
      details: assignmentApi.profitOrLossDetails,
      isAboveThreshold:
        assignmentApi.isProfitAboveThreshold === null
          ? null
          : Boolean(assignmentApi.isProfitAboveThreshold),
    },
    metrics: {
      planned: assignmentApi.time_planned,
      worked: assignmentApi.time_worked,
      ratio: assignmentApi.work_ratio,
      punctuality: assignmentApi.punctuality_record,
    },
    schedule: {
      from: assignmentApi.scheduledFrom,
      to: assignmentApi.scheduledTo,
    },
    work: {
      start: assignmentApi.startWork,
      end: assignmentApi.endWork,
    },
    value_fee: assignmentApi.value_fee,
    value_amount: assignmentApi.value_amount,
    monday: assignmentApi.monday ?? false,
    tuesday: assignmentApi.tuesday ?? false,
    wednesday: assignmentApi.wednesday ?? false,
    thursday: assignmentApi.thursday ?? false,
    friday: assignmentApi.friday ?? false,
    saturday: assignmentApi.saturday ?? false,
    sunday: assignmentApi.sunday ?? false,
    repeat_until: assignmentApi.repeat_until ?? 'No definido',
    companion_amount: assignmentApi.companion_amount,
    status: assignmentApi.status,
    created_by: assignmentApi.created_by,
  };
}
